import React from "react";
import { FormattedMessage } from "react-intl";

const InvalidToken = () => {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2>
          <FormattedMessage id="Screens.InvalidToken.Title" />
        </h2>
        <p>
          <FormattedMessage id="Screens.InvalidToken.Description" />
        </p>
      </div>
    );
  };

export default InvalidToken;